(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6291],{

/***/ 77293:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/jobs/[...details]",
      function () {
        return __webpack_require__(52722);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 56041:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MessageBox": function() { return /* binding */ MessageBox; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core_Button__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(282);
/* harmony import */ var _material_ui_icons_ReportProblemOutlined__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67123);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31393);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_3__);






var MessageBox = function(param) {
    var messageText = param.messageText, showButton = param.showButton, buttonLink = param.buttonLink, buttonText = param.buttonText, className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_style_module_scss__WEBPACK_IMPORTED_MODULE_3___default().container), className),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_3___default().icon),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_ReportProblemOutlined__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_3___default().messageBox),
                children: messageText
            }),
            showButton && buttonLink && buttonText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_3___default().buttonContainer),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Button__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    href: buttonLink,
                    className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_3___default().link),
                    children: buttonText
                })
            })
        ]
    });
};


/***/ }),

/***/ 41342:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ RadiusShadowContainer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77303);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_2__);



var RadiusShadowContainer = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_2___default().container),
        children: children
    });
};


/***/ }),

/***/ 89893:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ DisableEnquiryMessageBox; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/MessageBox/index.tsx
var MessageBox = __webpack_require__(56041);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./modules/DisableEnquiryMessageBox/DisableEnquiryMessageBox.module.scss
var DisableEnquiryMessageBox_module = __webpack_require__(60761);
var DisableEnquiryMessageBox_module_default = /*#__PURE__*/__webpack_require__.n(DisableEnquiryMessageBox_module);
;// CONCATENATED MODULE: ./modules/DisableEnquiryMessageBox/DisableEnquiryMessageBox.tsx
// import { Alert } from '@/app/components/Alert';





function DisableEnquiryMessageBox(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MessageBox.MessageBox, {
        className: classnames_default()((DisableEnquiryMessageBox_module_default()).messageBox, className),
        showButton: false,
        messageText: "Website Under Maintenance: Please note job enquiries and enquiry management are temporarily unavailable. Maintenance is due to end midday on Monday, March 10th."
    });
}

;// CONCATENATED MODULE: ./modules/DisableEnquiryMessageBox/index.ts



/***/ }),

/***/ 52722:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _details_; },
  "generateDescription": function() { return /* binding */ generateDescription; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./modules/Context/useAuth0User.tsx
var useAuth0User = __webpack_require__(65200);
// EXTERNAL MODULE: ./modules/DisableEnquiryMessageBox/index.ts + 1 modules
var DisableEnquiryMessageBox = __webpack_require__(89893);
// EXTERNAL MODULE: ./modules/JobFavouriteButton/index.tsx + 2 modules
var JobFavouriteButton = __webpack_require__(76242);
// EXTERNAL MODULE: ./utils/urlHelper.ts
var urlHelper = __webpack_require__(52484);
// EXTERNAL MODULE: ./components/JobApplicationStatusLabel/index.tsx
var JobApplicationStatusLabel = __webpack_require__(12042);
// EXTERNAL MODULE: ./components/JobInformation/index.tsx + 4 modules
var JobInformation = __webpack_require__(73037);
// EXTERNAL MODULE: ./components/RadiusShadowContainer/index.tsx
var RadiusShadowContainer = __webpack_require__(41342);
// EXTERNAL MODULE: ./components/ShareContainer/index.tsx + 1 modules
var ShareContainer = __webpack_require__(35079);
// EXTERNAL MODULE: ./constants/path.ts
var path = __webpack_require__(96703);
// EXTERNAL MODULE: ./modules/JobButton/index.tsx
var JobButton = __webpack_require__(91632);
// EXTERNAL MODULE: ./modules/JobListingJobCardList/index.tsx + 5 modules
var JobListingJobCardList = __webpack_require__(51241);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./utils/jobListingHelper.ts
var jobListingHelper = __webpack_require__(92628);
// EXTERNAL MODULE: ./utils/useAnalytics.ts + 2 modules
var useAnalytics = __webpack_require__(9800);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/List/List.js
var List = __webpack_require__(62822);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ListItem/ListItem.js
var ListItem = __webpack_require__(50998);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ListItemText/ListItemText.js
var ListItemText = __webpack_require__(95757);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/ApartmentOutlined.js
var ApartmentOutlined = __webpack_require__(23164);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/RoomOutlined.js
var RoomOutlined = __webpack_require__(24155);
// EXTERNAL MODULE: ./modules/SimilarJobs/SimilarJobs.module.scss
var SimilarJobs_module = __webpack_require__(46979);
var SimilarJobs_module_default = /*#__PURE__*/__webpack_require__.n(SimilarJobs_module);
;// CONCATENATED MODULE: ./modules/SimilarJobs/SimilarJobs.tsx









var SimilarJobs = function(param) {
    var jobs = param.jobs, referringJobNumber = param.referringJobNumber;
    var track = (0,useAnalytics/* useAnalytics */.z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (SimilarJobs_module_default()).container,
        children: !!jobs.length && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "subtitle1",
                    component: "h4",
                    className: (SimilarJobs_module_default()).title,
                    children: "Similar Jobs"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* default */.Z, {
                    dense: false,
                    children: jobs.map(function(job) {
                        var subspcialityOrSpeciality = job.subspeciality ? job.subspeciality : job.speciality;
                        var jobUrl = (0,jobListingHelper/* generateJobDetailsURL */.wZ)(job.jobNumber, job.grade, subspcialityOrSpeciality);
                        var locationInfo = (0,jobListingHelper/* generateLocationInfo */.WC)(job.locationDisplay, job.country, job.city);
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                                primary: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    prefetch: false,
                                    href: {
                                        pathname: jobUrl
                                    },
                                    as: jobUrl,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        onClick: function() {
                                            return track("Job Details", {
                                                jobNumber: job.jobNumber,
                                                "Details Origin": "Similar Jobs",
                                                "Details Action": "Title Link",
                                                referringJobNumber: referringJobNumber
                                            });
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "subtitle1",
                                            component: "h5",
                                            "data-testid": "title",
                                            children: job.title
                                        })
                                    })
                                }),
                                secondary: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                            variant: "body1",
                                            component: "p",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(RoomOutlined/* default */.Z, {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    "data-testid": "similar-job-location",
                                                    children: locationInfo
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                            variant: "body1",
                                            component: "p",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ApartmentOutlined/* default */.Z, {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    "data-testid": "work-type",
                                                    children: job.workType
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        }, job.id);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var SimilarJobs_SimilarJobs = (SimilarJobs);

;// CONCATENATED MODULE: ./modules/SimilarJobs/index.tsx


// EXTERNAL MODULE: ./modules/UserLoggedinContainer/index.tsx
var UserLoggedinContainer = __webpack_require__(74304);
// EXTERNAL MODULE: ./utils/limitTextLength.ts
var limitTextLength = __webpack_require__(69764);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(41749);
// EXTERNAL MODULE: ./pages/jobs/style.module.scss
var style_module = __webpack_require__(84306);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
;// CONCATENATED MODULE: ./pages/jobs/[...details].tsx






















var __N_SSP = true;
var generateDescription = function(grade, speciality, locationSummary, jobNumber) {
    var clientDescriptionPlainText = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "";
    //Removing tags //n
    var sanitizedDescription = clientDescriptionPlainText && clientDescriptionPlainText.replace(/\n/g, "");
    var description = "Medrecruit is seeking a ".concat(speciality, " - ").concat(grade, " in ").concat(locationSummary, ". ref# ").concat(jobNumber, ". ");
    return (0,limitTextLength/* textlengthLimit */.r)(description.concat(sanitizedDescription), 160);
};
var generateTitle = function(jobNumber, speciality) {
    var jobNumberSuffix = " - ".concat(jobNumber);
    var spaceForSpecialty = 60 - jobNumberSuffix.length;
    return "".concat(speciality.substring(0, spaceForSpecialty)).concat(jobNumberSuffix);
};
/**
 * The page will be used to render the job details page, jobNumber or UUID of job used to render the page
 * /jobs/grade/speciality/jnxxxxxxxx
 * /jobs/grade/jnxxxxxxxx
 * /jobs/jnxxxxxxxx
 */ var Job = function(param) {
    var detail = param.detail, isExpired = param.isExpired, similarJobs = param.similarJobs, addJobNumberQueryParam = param.addJobNumberQueryParam, disableEnquireAndWithdrawButtons = param.disableEnquireAndWithdrawButtons;
    var ref;
    var router = (0,next_router.useRouter)();
    var track = (0,useAnalytics/* useAnalytics */.z)();
    var user = (0,useAuth0User/* useAuth0User */.a)().user;
    (0,react.useEffect)(function() {
        if (detail) {
            track("Job Details page loaded", {
                jobNumber: detail.jobNumber,
                open: !isExpired
            });
        }
    }, [
        router.query
    ]);
    if (!detail) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(UserLoggedinContainer/* UserLoggedinContainer */.C, {
            style: UserLoggedinContainer/* ContainerStyle.MEDIUM_BLUE_BANNER */.N.MEDIUM_BLUE_BANNER,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (style_module_default()).unavailableHeader,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        children: "Sorry, unable to find this job listing."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        className: (style_module_default()).searchBtn,
                        variant: "contained",
                        size: "medium",
                        color: "secondary",
                        onClick: function() {
                            router.push(path/* PATH.JOBS */.m.JOBS);
                        },
                        children: "Return to job search"
                    })
                ]
            })
        });
    }
    var id = detail.id, description = detail.description, clientDescription = detail.clientDescription, clientDescriptionPlainText = detail.clientDescriptionPlainText, jobNumber = detail.jobNumber, title = detail.title, grade = detail.grade, speciality = detail.speciality, subspeciality = detail.subspeciality, isSaved = detail.isSaved, appliedStatus = detail.appliedStatus, accountName = detail.accountName, displayClientName = detail.displayClientName, clientNameMessage = detail.clientNameMessage;
    var locationSummary = (0,jobListingHelper/* generateLocationInfo */.WC)(detail.locationDisplay, detail.country, detail.city);
    var hasSimilarJobs = similarJobs && similarJobs.length > 0;
    var newLineEncoding = "%0d%0a";
    var seoSpecialtyText = speciality || "";
    var specialtyOrSubspecialityText = subspeciality ? subspeciality : seoSpecialtyText;
    var seoDescription = generateDescription(grade, specialtyOrSubspecialityText, locationSummary, jobNumber, clientDescriptionPlainText);
    var seoTitle = generateTitle(jobNumber, specialtyOrSubspecialityText);
    var canonicalUrl = (0,jobListingHelper/* generateJobDetailsURL */.wZ)(jobNumber, grade, specialtyOrSubspecialityText);
    var ref1, ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            isExpired && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(UserLoggedinContainer/* UserLoggedinContainer */.C, {
                    style: UserLoggedinContainer/* ContainerStyle.MEDIUM_BLUE_BANNER */.N.MEDIUM_BLUE_BANNER,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                            noindex: true,
                            nofollow: true
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (style_module_default()).unavailableHeader,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    children: "Sorry, this job listing is no longer available."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        "Job reference: ",
                                        jobNumber
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    className: (style_module_default()).searchBtn,
                                    variant: "contained",
                                    size: "medium",
                                    color: "secondary",
                                    onClick: function() {
                                        router.push(path/* PATH.JOBS */.m.JOBS);
                                    },
                                    children: "Return to job search"
                                })
                            ]
                        }),
                        hasSimilarJobs && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (style_module_default()).similarJobTitle,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        children: "Here are some other jobs that may be similar."
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (style_module_default()).similarJobs,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(JobListingJobCardList/* default */.Z, {
                                        jobs: similarJobs,
                                        suppressCTABanner: true
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            !isExpired && /*#__PURE__*/ (0,jsx_runtime.jsx)(UserLoggedinContainer/* UserLoggedinContainer */.C, {
                style: UserLoggedinContainer/* ContainerStyle.BACKDROP_BLUE_BANNER */.N.BACKDROP_BLUE_BANNER,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (style_module_default()).paddingBox,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                            title: seoTitle,
                            description: seoDescription,
                            noindex: true,
                            nofollow: true,
                            openGraph: {
                                title: seoTitle,
                                description: seoDescription,
                                type: "website"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RadiusShadowContainer/* RadiusShadowContainer */.o, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (style_module_default()).article,
                                    children: [
                                        disableEnquireAndWithdrawButtons && /*#__PURE__*/ (0,jsx_runtime.jsx)(DisableEnquiryMessageBox/* default */.Z, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                            container: true,
                                            spacing: 3,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                                    item: true,
                                                    md: 8,
                                                    xs: 12,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                            variant: "caption",
                                                            component: "h1",
                                                            className: (style_module_default()).speciality,
                                                            children: grade
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                            variant: "h4",
                                                            component: "h2",
                                                            className: (style_module_default()).detailTitle,
                                                            children: subspeciality ? subspeciality : speciality
                                                        }),
                                                        user && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: (style_module_default()).locationAndClient,
                                                            children: displayClientName ? accountName : clientNameMessage || "Client Name Withheld"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: (style_module_default()).locationAndClient,
                                                            "data-testid": "job-location-details",
                                                            children: locationSummary
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                    item: true,
                                                    md: 4,
                                                    xs: 12,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (style_module_default()).actions,
                                                        children: [
                                                            appliedStatus ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (style_module_default()).status,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(JobApplicationStatusLabel/* JobApplicationStatusLabel */.h, {
                                                                    status: appliedStatus
                                                                })
                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(JobButton/* JobButton */.E, {
                                                                        id: id,
                                                                        jobNumber: jobNumber,
                                                                        url: canonicalUrl,
                                                                        addJobNumberQueryParam: addJobNumberQueryParam,
                                                                        disableEnquireAndWithdrawButtons: disableEnquireAndWithdrawButtons,
                                                                        text: disableEnquireAndWithdrawButtons && !user ? "Register" : "Enquire"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(JobFavouriteButton/* default */.Z, {
                                                                        id: id,
                                                                        jobNumber: jobNumber,
                                                                        favourited: isSaved,
                                                                        style: "outlined"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareContainer/* default */.Z, {
                                                                jobOrArticleShare: "jobshare",
                                                                id: id,
                                                                className: (style_module_default()).shareBox,
                                                                emailTitle: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                    children: [
                                                                        "Who would you like ",
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                                        " to send this job to?"
                                                                    ]
                                                                }),
                                                                emailSubject: "".concat((ref1 = user === null || user === void 0 ? void 0 : user.given_name) !== null && ref1 !== void 0 ? ref1 : "Medrecruit", " recommended a job for you"),
                                                                emailBody: "View the job recommended for you by ".concat((ref2 = user === null || user === void 0 ? void 0 : user.given_name) !== null && ref2 !== void 0 ? ref2 : "Medrecruit", " ").concat(newLineEncoding).concat(encodeURI((0,urlHelper/* getUtmShareUrl */.En)("jobshare", "".concat((ref = globalThis.location) === null || ref === void 0 ? void 0 : ref.origin).concat(canonicalUrl), "email"))),
                                                                facebookTitle: title,
                                                                shareTrackingProps: {
                                                                    name: "Share Job",
                                                                    details: {
                                                                        "Share Origin": "Job Detail",
                                                                        jobNumber: jobNumber
                                                                    }
                                                                }
                                                            })
                                                        ]
                                                    })
                                                }, id)
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                            className: (style_module_default()).hr
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                            container: true,
                                            spacing: 3,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                                    item: true,
                                                    md: 8,
                                                    xs: 12,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                            variant: "subtitle1",
                                                            component: "h3",
                                                            className: (style_module_default()).detailSubTitle,
                                                            children: "Job Description:"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (style_module_default()).content,
                                                            dangerouslySetInnerHTML: {
                                                                __html: description || "Not Available"
                                                            }
                                                        }),
                                                        clientDescription && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                    variant: "subtitle1",
                                                                    component: "h3",
                                                                    className: (style_module_default()).detailSubTitle,
                                                                    children: "Client Description:"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: (style_module_default()).content,
                                                                    dangerouslySetInnerHTML: {
                                                                        __html: "<p>".concat(clientDescription, "</p>")
                                                                    }
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                                    item: true,
                                                    md: 4,
                                                    xs: 12,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (style_module_default()).informationBox,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(JobInformation/* JobInformation */.ym, {
                                                                job: detail
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SimilarJobs_SimilarJobs, {
                                                            referringJobNumber: jobNumber,
                                                            jobs: similarJobs || []
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                                    item: true,
                                                    md: 8,
                                                    xs: 12,
                                                    children: [
                                                        !appliedStatus && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                            item: true,
                                                            md: 5,
                                                            xs: 12,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (style_module_default()).detailContentApply,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(JobButton/* JobButton */.E, {
                                                                    id: id,
                                                                    jobNumber: jobNumber,
                                                                    url: canonicalUrl,
                                                                    addJobNumberQueryParam: addJobNumberQueryParam,
                                                                    disableEnquireAndWithdrawButtons: disableEnquireAndWithdrawButtons,
                                                                    text: disableEnquireAndWithdrawButtons && !user ? "Register" : "Enquire"
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            className: (style_module_default()).reference,
                                                            children: [
                                                                "Job reference: ",
                                                                jobNumber
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var _details_ = (Job);


/***/ }),

/***/ 31393:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__0v3zv","buttonContainer":"style_buttonContainer__qyxUM","icon":"style_icon__lWJOy","MuiSvgIcon-root":"style_MuiSvgIcon-root__LGQOC","messageBox":"style_messageBox__ix14X","link":"style_link__Rcgvm"};

/***/ }),

/***/ 77303:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__A_XKr"};

/***/ }),

/***/ 60761:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"messageBox":"DisableEnquiryMessageBox_messageBox__U5_Sf"};

/***/ }),

/***/ 46979:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"SimilarJobs_container__Drmfp","title":"SimilarJobs_title__FjXj4"};

/***/ }),

/***/ 84306:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"pageHeadingCentered":"style_pageHeadingCentered__JWTNl","paddingBox":"style_paddingBox__VPFwP","speciality":"style_speciality__Y_Pxh","content":"style_content__YcKSS","noLoingNotice":"style_noLoingNotice__SfNCj","informationBox":"style_informationBox__tGsFl","hr":"style_hr__qLQSm","actions":"style_actions__UPrtJ","detailTitle":"style_detailTitle__VO4bV","locationAndClient":"style_locationAndClient__grmXs","detailSubTitle":"style_detailSubTitle__HKqRv","detailContentApply":"style_detailContentApply__Mkju4","reference":"style_reference__S43WL","article":"style_article__4v2W1","landingContainer":"style_landingContainer__lg_xE","title":"style_title___Ri5x","more":"style_more__RW_RU","emptyJob":"style_emptyJob__zOwAM","link":"style_link__XPI_n","unavailableHeader":"style_unavailableHeader__0iKXc","searchBtn":"style_searchBtn___YQef","similarJobTitle":"style_similarJobTitle__zBdr_","shareBox":"style_shareBox__IaYkO","status":"style_status___9y_n","posRel":"style_posRel__BLElf","jobListContainer":"style_jobListContainer__E01Bx","similarJobs":"style_similarJobs__D_D6R"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2491,5675,1399,4872,9043,1086,7243,2628,933,7422,1241,9774,2888,179], function() { return __webpack_exec__(77293); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);